export default "__VITE_ASSET__CPooSzWa__"